function removeDuplicateObjects<T, K extends keyof T>(array: T[], property: K): T[] {
  const uniqueNames = new Set<T[K]>();

  return array.filter(element => {
    const isDuplicate = uniqueNames.has(element[property]);

    if (!isDuplicate) {
      uniqueNames.add(element[property]);

      return true;
    }

    return false;
  });
}
export { removeDuplicateObjects };
